import { createSelector } from '@reduxjs/toolkit';
import { getImmutableCompatible } from 'src/utils/immutableUtils';

const getParams = (state) => getImmutableCompatible(state, 'headerWidget');

/**
 * Виджет в шапке открыт/закрыт
 */
export const getHeaderWidgetIsOpen = createSelector(getParams, (params) =>
  params.get('showPopup'),
);

/**
 * Идет ли загрузка
 */
export const getHeaderWidgetIsFetching = createSelector(getParams, (params) =>
  params.get('fetch'),
);

/**
 * Загрузка завершена
 */
export const getHeaderWidgetLoaded = createSelector(getParams, (params) =>
  params.get('loaded'),
);

/**
 * Виджет доступен
 */
export const getHeaderWidgetInit = createSelector(getParams, (params) =>
  params.get('initWidget'),
);

/**
 * Путь до апи в зависимости от окружения
 */
export const getHeaderWidgetPathToApi = createSelector(getParams, (params) =>
  params.get('pathToApi'),
);
